export const creditShared = {
    layout: {
        productInfo: {
            showOutstandingAndBalanceAmount: true,
            showCurrentCycleTurnover: true,
        },
    },
    overview: {
        showOutstandingWithDueDate: true,
        showBalanceWithLimitInfo: true,
    },
    preferOutstandingAmount: true,
    menu: {
        supplementary: {
            enabled: true,
        },
    },
    supplementary: {
        enabled: true,
        allowHiddenCardImage: true,
    },
    functions: {
        payUp: {
            allowAmountHigherThenBalance: true,
            idField: 'hr-id',
            validAccounts: {
                currentAndSavingsAccounts: true,
            },
        },
    },
    settings: {
        productWhitelist: ['MAIN', 'AUTHORIZED_STANDALONE'],
    },
    showAuthorizedAsSubCard: true,
};
